import styled from "styled-components"

export default function AchievementCard({ children }) {
  return <CardBlock>{children}</CardBlock>
}

const CardBlock = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vw * (165 / 375));
  min-height: calc(100vw * (193 / 375));
  background: #fff;
  border-radius: calc(100vw * (10 / 375));
  box-shadow: 0px 0px 20px rgba(191, 191, 191, 0.5);
  margin-bottom: calc(100vw * (23 / 375));
  padding: calc(100vw * (12 / 375)) calc(100vw * (20 / 375)) calc(100vw * (42 / 375))
    calc(100vw * (27 / 375));
`
